module.exports = __webpack_public_path__ + "img/question-mark.1ba4dc87.svg";